import React from "react";
import PropTypes from "prop-types";
import { css } from "@emotion/react";
import {
  baseColor1,
  baseColor2,
  buttonDisabledBgColor,
  buttonDisabledColor,
} from "../styles/color";

const Button = (props) => {
  const styles = css`
    display: inline-grid;
    place-items: center;
    height: ${props.dense ? "35px" : "45px"};
    ${props.fullWidth && "width: 100%;"}
    box-sizing: border-box;
    background-color: ${props.bgColor};
    color: ${props.color};
    font-size: 1rem;
    white-space: nowrap;
    border: 2px solid ${props.outlined ? props.color : props.bgColor};
    border-radius: 0.5rem;
    padding: ${props.dense ? "0 7px" : "0 1rem"};
    cursor: pointer;

    &:disabled {
      background-color: ${props.overrideDisabledStyles
        ? props.bgColor
        : buttonDisabledBgColor};
      color: ${props.overrideDisabledStyles
        ? props.color
        : buttonDisabledColor};
      cursor: not-allowed;
      border-color: ${props.overrideDisabledStyles
        ? props.bgColor
        : buttonDisabledBgColor};
    }
  `;

  const content = css`
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 0.5rem;
    ${props.flipIcon && "flex-direction: row-reverse;"}
  `;

  return (
    <button
      css={styles}
      type={props.type}
      disabled={props.disabled}
      onClick={props.onClick}
    >
      <span css={content}>
        {props.text}
        {props.icon}
      </span>
    </button>
  );
};

Button.defaultProps = {
  type: "button",
  text: "",
  icon: undefined,
  flipIcon: false,
  bgColor: baseColor2,
  color: baseColor1,
  disabled: false,
  overrideDisabledStyles: false,
  fullWidth: false,
  outlined: false,
  dense: false,
  onClick: undefined,
};

Button.propTypes = {
  type: PropTypes.string,
  text: PropTypes.string,
  icon: PropTypes.element,
  flipIcon: PropTypes.bool,
  bgColor: PropTypes.string,
  color: PropTypes.string,
  disabled: PropTypes.bool,
  overrideDisabledStyles: PropTypes.bool,
  fullWidth: PropTypes.bool,
  outlined: PropTypes.bool,
  dense: PropTypes.bool,
  onClick: PropTypes.func,
};

export default Button;
